import { render, staticRenderFns } from "./NumerexCreate.vue?vue&type=template&id=5dd6bf87"
import script from "./NumerexCreate.vue?vue&type=script&lang=js"
export * from "./NumerexCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports